import { useQuery } from "react-query";
import inventoryClient from "../clients/inventoryClient";

function useVendors(establishmentId) {
    const queryReturnValues = useQuery(
        ["vendors", { establishmentId }],
        inventoryClient.getDistributorsReactQuery,
        {
            staleTime: 1000 * 60 * 10
        }
    );

    if (queryReturnValues.isLoading) {
        return [queryReturnValues, {}];
    } else {
        const responseMap = {};
        queryReturnValues.data.vendors.forEach(x => responseMap[x.id] = x);
        queryReturnValues.data.archivedVendors.forEach(x => responseMap[x.id] = x);
        return [queryReturnValues, responseMap];
    }
}

export default useVendors;